// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","inner":"Loader_inner__p3BGw"};